import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { HttpHeaders, HttpErrorResponse, HttpClient} from '@angular/common/http';
import { map, tap, catchError } from 'rxjs/operators';
import { CompanyInfo } from '../../models/company';
// @ts-ignore
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AnyNaptrRecord } from 'dns';

// noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols,JSMethodCanBeStatic,DuplicatedCode
@Injectable({
  providedIn: 'root'
})
export class ClientsUsersService {
  private API_URL = environment.apiUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private router: Router) {
  }

  getAllClients(): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllClients`);
  }

  getAllClientsByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllClientsByRegion?theAreaLocationId=${id}`);
  }

  getAllClientsByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllClientsByTown?theTownLocationId=${id}`);
  }

  getAllClientsByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllClientsByStation?theStationLocationId=${id}`);
  }

  getBodaBodaCustomer(): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaCustomer`);
  }

  getBodaBodaCustomerByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaCustomerByRegion?theAreaLocationId=${id}`);
  }

  getBodaBodaCustomerByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaCustomerByTown?theTownLocationId=${id}`);
  }

  getBodaBodaCustomerByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaCustomerByStation?theStationLocationId=${id}`);
  }

  getTaxiCustomers(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiCustomers`);
  }

  getTaxiCustomersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiCustomersByRegion?theAreaLocationId=${id}`);
  }

  getTaxiCustomersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiCustomersByTown?theTownLocationId=${id}`);
  }

  getTaxiCustomersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiCustomersByStation?theStationLocationId=${id}`);
  }

  getMicroloanCustomers(): any {
    return this.http.get(`${this.API_URL}/api/reports/getMicroloanCustomers`);
  }

  getMicroloanCustomersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getMicroloanCustomersByRegion?theAreaLocationId=${id}`);
  }

  getMicroloanCustomersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getMicroloanCustomersByTown?theTownLocationId=${id}`);
  }

  getMicroloanCustomersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getMicroloanCustomersByStation?theStationLocationId=${id}`);
  }

  getLoanCompletedCustomer(): any {
    return this.http.get(`${this.API_URL}/api/reports/getLoanCompletedCustomer`);
  }

  getLoanCompletedCustomerByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getLoanCompletedCustomerByRegion?theAreaLocationId=${id}`);
  }

  getLoanCompletedCustomerByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getLoanCompletedCustomerByTown?theTownLocationId=${id}`);
  }

  getLoanCompletedCustomerByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getLoanCompletedCustomerByStation?theStationLocationId=${id}`);
  }

  getSavingsCustomer(): any {
    return this.http.get(`${this.API_URL}/api/reports/getLoanCompletedCustomer`);
  }

  getSavingsCustomerByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getSavingsCustomerByRegion?theAreaLocationId=${id}`);
  }

  getSavingsCustomerByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getSavingsCustomerByTown?theTownLocationId=${id}`);
  }

  getSavingsCustomerByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getSavingsCustomerByStation?theStationLocationId=${id}`);
  }

  getNewCustomerPerPeriod(postData: any): any {
    return this.http.post(`${this.API_URL}/api/reports/getNewCustomerPerPeriod`, postData);
  }

  getNewCustomerPerPeriodByRegion(postData: any): any {
    return this.http.post(`${this.API_URL}/api/reports/getNewCustomerPerPeriodByRegion`, postData);
  }

  getNewCustomerPerPeriodByTown(postData: any): any {
    return this.http.post(`${this.API_URL}/api/reports/getNewCustomerPerPeriodByTown`, postData);
  }

  getNewCustomerPerPeriodByStation(postData: any): any {
    return this.http.post(`${this.API_URL}/api/reports/getNewCustomerPerPeriodByStation`, postData);
  }

  getBodaBodaClusters(): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaClusters`);
  }

  getBodaBodaClustersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaClustersByRegion?theAreaLocationId=${id}`);
  }

  getBodaBodaClustersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaClustersByTown?theTownLocationId=${id}`);
  }

  getBodaBodaClustersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaClustersByStation?theStationLocationId=${id}`);
  }

  getBodaBodaStages(): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStages`);
  }

  getBodaBodaStagesByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStagesByRegion?theAreaLocationId=${id}`);
  }

  getBodaBodaStagesByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStagesByTown?theTownLocationId=${id}`);
  }

  getBodaBodaStagesByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStagesByStation?theStationLocationId=${id}`);
  }

  getTaxiParks(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiParks`);
  }

  getTaxiParksByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiParksByRegion?theAreaLocationId=${id}`);
  }

  getTaxiParksByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiParksByTown?theTownLocationId=${id}`);
  }

  getTaxiParksByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiParksByStation?theStationLocationId=${id}`);
  }

  getTaxiStages(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStages`);
  }

  getTaxiStagesByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStagesByRegion?theAreaLocationId=${id}`);
  }

  getTaxiStagesByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStagesByTown?theTownLocationId=${id}`);
  }

  getTaxiStagesByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStagesByStation?theStationLocationId=${id}`);
  }

  getBodaBodaStagesPerCluster(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStagesPerCluster?stageClusterId=${id}`);
  }

  getTaxiStagesPerTaxiPark(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStagesPerTaxiPark?taxiParkId=${id}`);
  }

  getCustomersPerBodaBodaCluster(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getCustomersPerBodaBodaCluster?stageClusterId=${id}`);
  }

  getCustomersPerBodaBodaStage(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getCustomersPerBodaBodaStage?bodabodaStageId=${id}`);
  }

  getCustomersPerTaxiPark(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getCustomersPerTaxiPark?taxiParkId=${id}`);
  }

  getCustomersPerTaxiStage(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getCustomersPerTaxiStage?taxiStageId=${id}`);
  }

  getBodaBodaStageChairmenReport(): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStageChairmenReport`);
  }

  getBodaBodaStageChairmenReportByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStageChairmenReportByRegion?theAreaLocationId=${id}`);
  }

  getBodaBodaStageChairmenReportByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStageChairmenReportByTown?theTownLocationId=${id}`);
  }

  getBodaBodaStageChairmenReportByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getBodaBodaStageChairmenReportByStation?theStationLocationId=${id}`);
  }

  getTaxiStageChairmenReport(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStageChairmenReport`);
  }

  getTaxiStageChairmenReportByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStageChairmenReportByRegion?theAreaLocationId=${id}`);
  }

  getTaxiStageChairmenReportByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStageChairmenReportByTown?theTownLocationId=${id}`);
  }

  getTaxiStageChairmenReportByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTaxiStageChairmenReportByStation?theStationLocationId=${id}`);
  }

  getAllUsers(): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsers`);
  }

  getAllUsersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsersByRegion?theAreaLocationId=${id}`);
  }

  getAllUsersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsersByTown?theTownLocationId=${id}`);
  }

  getAllUsersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsersByStation?theStationLocationId=${id}`);
  }

  getAllApprovedUsers(): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllApprovedUsers`);
  }

  getAllApprovedUsersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllApprovedUsersByRegion?theAreaLocationId=${id}`);
  }

  getAllApprovedUsersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllApprovedUsersByTown?theTownLocationId=${id}`);
  }

  getAllApprovedUsersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllApprovedUsersByStation?theStationLocationId=${id}`);
  }

  getAllUsersPendingApproval(): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsersPendingApproval`);
  }

  getAllUsersPendingApprovalByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsersPendingApprovalByRegion?theAreaLocationId=${id}`);
  }

  getAllUsersPendingApprovalByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsersPendingApprovalByTown?theTownLocationId=${id}`);
  }

  getAllUsersPendingApprovalByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getAllUsersPendingApprovalByStation?theStationLocationId=${id}`);
  }

  getTotalTownLocationsByArea(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTownLocationsByArea?theAreaLocationId=${id}`);
  }

  getTotalStationLocationsByArea(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalStationLocationsByArea?theAreaLocationId=${id}`);
  }

  getTotalStationLocationsByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalStationLocationsByTown?theTownLocationId=${id}`);
  }

  getTotalBodaBodaStages(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaStages`);
  }

  getTotalBodaBodaStagesByArea(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaStagesByArea?theAreaLocationId=${id}`);
  }

  getTotalBodaBodaStagesByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaStagesByTown?theTownLocationId=${id}`);
  }

  getTotalBodaBodaStagesByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaStagesByStation?theStationLocationId=${id}`);
  }

  getTotalTaxiStages(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiStages`);
  }

  getTotalTaxiStagesByArea(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiStagesByArea?theAreaLocationId=${id}`);
  }

  getTotalTaxiStagesByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiStagesByTown?theTownLocationId=${id}`);
  }

  getTotalTaxiStagesByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiStagesByStation?theStationLocationId=${id}`);
  }

  getTotalClients(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClients`);
  }

  getTotalClientsByArea(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsByArea?theAreaLocationId=${id}`);
  }

  getTotalClientsByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsByTown?theTownLocationId=${id}`);
  }

  getTotalClientsByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsByStation?theStationLocationId=${id}`);
  }

  getTotalClientsWhoBorrowed(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoBorrowed`);
  }

  getTotalClientsWhoBorrowedByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoBorrowedByRegion?theAreaLocationId=${id}`);
  }

  getTotalClientsWhoBorrowedByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoBorrowedByTown?theTownLocationId=${id}`);
  }

  getTotalClientsWhoBorrowedByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoBorrowedByStation?theStationLocationId=${id}`);
  }

  getTotalClientsWhoSaved(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoSaved`);
  }

  getTotalClientsWhoSavedByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoSavedByRegion?theAreaLocationId=${id}`);
  }

  getTotalClientsWhoSavedByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoSavedByTown?theTownLocationId=${id}`);
  }

  getTotalClientsWhoSavedByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoSavedByStation?theStationLocationId=${id}`);
  }

  getTotalClientsWhoPaid(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoPaid`);
  }

  getTotalClientsWhoPaidByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoPaidByRegion?theAreaLocationId=${id}`);
  }

  getTotalClientsWhoPaidByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoPaidByTown?theTownLocationId=${id}`);
  }

  getTotalClientsWhoPaidByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalClientsWhoPaidByStation?theStationLocationId=${id}`);
  }

  // getTotalNoOfDefaulters(): any {
  //   return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDefaulters`);
  // }
  // getTotalNoOfDefaultersByRegion(id: number): any {
  //   return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDefaultersByRegion?theAreaLocationId=${id}`);
  // }
  // getTotalNoOfDefaultersByTown(id: number): any {
  //   return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDefaultersByTown?theTownLocationId=${id}`);
  // }
  // getTotalNoOfDefaultersByStation(id: number): any {
  //   return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDefaultersByStation?theStationLocationId=${id}`);
  // }
  getTotalNoOfDebtsRecovered(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDebtsRecovered`);
  }

  getTotalNoOfDebtsRecoveredByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDebtsRecoveredByRegion?theAreaLocationId=${id}`);
  }

  getTotalNoOfDebtsRecoveredByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDebtsRecoveredByTown?theTownLocationId=${id}`);
  }

  getTotalNoOfDebtsRecoveredByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDebtsRecoveredByStation?theStationLocationId=${id}`);
  }

  getTotalNoOfClientPaidInFull(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInFull`);
  }

  getTotalNoOfClientPaidInFullByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInFullByRegion?theAreaLocationId=${id}`);
  }

  getTotalNoOfClientPaidInFullByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInFullByTown?theTownLocationId=${id}`);
  }

  getTotalNoOfClientPaidInFullByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInFullByStation?theStationLocationId=${id}`);
  }

  getTotalNoOfClientPaidInInstalment(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInInstalment`);
  }

  getTotalNoOfClientPaidInInstalmentByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInInstalmentByRegion?theAreaLocationId=${id}`);
  }

  getTotalNoOfClientPaidInInstalmentByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInInstalmentByTown?theTownLocationId=${id}`);
  }

  getTotalNoOfClientPaidInInstalmentByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfClientPaidInInstalmentByStation?theStationLocationId=${id}`);
  }

  getTotalAmountRecovered(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountRecovered`);
  }

  getTotalAmountRecoveredByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountRecoveredByRegion?theAreaLocationId=${id}`);
  }

  getTotalAmountRecoveredByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountRecoveredByTown?theTownLocationId=${id}`);
  }

  getTotalAmountRecoveredByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountRecoveredByStation?theStationLocationId=${id}`);
  }

  getTotalAmountUnPaid(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountUnPaid`);
  }

  getTotalAmountUnPaidByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountUnPaidByRegion?theAreaLocationId=${id}`);
  }

  getTotalAmountUnPaidByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountUnPaidByTown?theTownLocationId=${id}`);
  }

  getTotalAmountUnPaidByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalAmountUnPaidByStation?theStationLocationId=${id}`);
  }

  getTotalFloatAmount(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalFloatAmount`);
  }

  getTotalFloatAmountByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalFloatAmountByRegion?theAreaLocationId=${id}`);
  }

  getTotalFloatAmountByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalFloatAmountByTown?theTownLocationId=${id}`);
  }

  getTotalFloatAmountByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalFloatAmountByStation?theStationLocationId=${id}`);
  }

  getTotalLoans(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalLoans`);
  }

  getTotalLoansByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalLoansByRegion?theAreaLocationId=${id}`);
  }

  getTotalLoansByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalLoansByTown?theTownLocationId=${id}`);
  }

  getTotalLoansByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalLoansByStation?theStationLocationId=${id}`);
  }

  getTotalBodaBodaLoanDefaulters(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanDefaulters`);
  }

  getTotalBodaBodaLoanDefaultersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanDefaultersByRegion?theAreaLocationId=${id}`);
  }

  getTotalBodaBodaLoanDefaultersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanDefaultersByTown?theTownLocationId=${id}`);
  }

  getTotalBodaBodaLoanDefaultersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanDefaultersByStation?theStationLocationId=${id}`);
  }

  getTotalTaxiLoanDefaulters(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalNoOfDefaulters`);
  }

  getTotalTaxiLoanDefaultersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanDefaultersByRegion?theAreaLocationId=${id}`);
  }

  getTotalTaxiLoanDefaultersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanDefaultersByTown?theTownLocationId=${id}`);
  }

  getTotalTaxiLoanDefaultersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanDefaultersByStation?theStationLocationId=${id}`);
  }

  getTotalMircoLoanDefaulters(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMircoLoanDefaulters`);
  }

  getTotalMicroLoanDefaultersByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanDefaultersByRegion?theAreaLocationId=${id}`);
  }

  getTotalMicroLoanDefaultersByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanDefaultersByTown?theTownLocationId=${id}`);
  }

  getTotalMicroLoanDefaultersByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanDefaultersByStation?theStationLocationId=${id}`);
  }

  getTotalBodaBodaLoanRecovery(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanRecovery`);
  }

  getTotalBodaBodaLoanRecoveryByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanRecoveryByRegion?theAreaLocationId=${id}`);
  }

  getTotalBodaBodaLoanRecoveryByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanRecoveryByTown?theTownLocationId=${id}`);
  }

  getTotalBodaBodaLoanRecoveryByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanRecoveryByStation?theStationLocationId=${id}`);
  }

  getTotalTaxiLoanRecovery(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanRecovery`);
  }

  getTotalTaxiLoanRecoveryByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanRecoveryByRegion?theAreaLocationId=${id}`);
  }

  getTotalTaxiLoanRecoveryByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanRecoveryByTown?theTownLocationId=${id}`);
  }

  getTotalTaxiLoanRecoveryByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanRecoveryByStation?theStationLocationId=${id}`);
  }

  getTotalMircoLoanRecovery(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMircoLoanRecovery`);
  }

  getTotalTheMicroLoanRecoveryByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTheMicroLoanRecoveryByRegion?theAreaLocationId=${id}`);
  }

  getTotalMicroLoanRecoveryByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanRecoveryByTown?theTownLocationId=${id}`);
  }

  getTotalMicroLoanRecoveryByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanRecoveryByStation?theStationLocationId=${id}`);
  }

  getTotalBodaBodaLoanEnforcement(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanEnforcement`);
  }

  getTotalBodaBodaLoanEnforcementByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanEnforcementByRegion?theAreaLocationId=${id}`);
  }

  getTotalBodaBodaLoanEnforcementByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanEnforcementByTown?theTownLocationId=${id}`);
  }

  getTotalBodaBodaLoanEnforcementByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalBodaBodaLoanEnforcementByStation?theStationLocationId=${id}`);
  }

  getTotalTaxiLoanEnforcement(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanEnforcement`);
  }

  getTotalTaxiLoanEnforcementByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanEnforcementByRegion?theAreaLocationId=${id}`);
  }

  getTotalTaxiLoanEnforcementByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanEnforcementByTown?theTownLocationId=${id}`);
  }

  getTotalTaxiLoanEnforcementByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalTaxiLoanEnforcementByStation?theStationLocationId=${id}`);
  }

  getTotalMircoLoanEnforcement(): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMircoLoanEnforcement`);
  }

  getTotalMicroLoanEnforcementByRegion(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanEnforcementByRegion?theAreaLocationId=${id}`);
  }

  getTotalMicroLoanEnforcementByTown(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanEnforcementByTown?theTownLocationId=${id}`);
  }

  getTotalMicroLoanEnforcementByStation(id: number): any {
    return this.http.get(`${this.API_URL}/api/reports/getTotalMicroLoanEnforcementByStation?theStationLocationId=${id}`);
  }

  private handleCompanySetupError(errorResponse: HttpErrorResponse): any {

    if (errorResponse.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', errorResponse.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${errorResponse.status}, ` +
        `body was: ${errorResponse.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(`Company Setup failed!!
      ${(errorResponse.status === 500 || errorResponse.status === 0 || errorResponse.status === 200) ?
      'The Back End was not able to Handle this Request' : errorResponse.error}
  !!`);
  }

  private OtherErrors(errorResponse: HttpErrorResponse): any {

    if (errorResponse.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', errorResponse.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${errorResponse.status}, ` +
        `body was: ${errorResponse.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('The backend was not able to handle this request. Please contact system admin 0781331616.');
  }
}
